import { Injectable } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

const RELOAD_FLAG_KEY = 'vipbc-chunk-error-reload';
// Chromium: "Failed to fetch dynamically imported module", Firefox: "error loading dynamically
// imported module", Safari: "Importing a module script failed."
export const CHUNK_ERROR_PATTERN =
    /ChunkLoadError|Loading chunk .* failed|failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i;

let reloadPending = false;

// Used by Sentry beforeSend to drop chunk errors that the scheduled reload is about to fix.
// Errors after the reload was already spent (flag in sessionStorage) are still reported.
export function isChunkReloadPending(): boolean {
    return reloadPending;
}

// After a new deploy, a tab left open on the old build can still be routed to a lazy
// chunk file the deploy already deleted. Reloading picks up the current index.html/chunks.
//
// The flag is intentionally never cleared on successful navigation — it must survive
// for the whole tab lifetime (sessionStorage does that across a reload). Clearing it on
// NavigationEnd would allow an unlimited number of reloads per tab: a route that always
// fails to load its chunk (a real bug, not a stale deploy) combined with any redirect
// through a working route in between would auto-reload forever.
@Injectable({ providedIn: 'root' })
export class ChunkErrorReloadService {
    constructor(
        private _router: Router,
        private _toastr: ToastrService,
    ) {}

    init(): void {
        this._router.events.subscribe(event => {
            if (event instanceof NavigationError && CHUNK_ERROR_PATTERN.test(event.error?.message ?? '')) {
                this._reload();
            }
        });
    }

    private _reload(): void {
        if (sessionStorage.getItem(RELOAD_FLAG_KEY)) {
            return;
        }
        sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
        reloadPending = true;

        this._toastr.info('Byla vydána nová verze aplikace, stránka se obnoví...');
        setTimeout(() => window.location.reload(), 1000);
    }
}
